









































































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "@/mixins/axiosMixin";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import {
  MedicalSpecification,
  MedicalInvoice
} from "@/components/medicalEdit/types";
import { SelectItem, PulldownItem } from "@/types";
import MedicalSpecificationRev5 from "@/components/medicalEdit/specification/MedicalSpecificationRev5.vue";
import MedicalSpecificationRev4 from "@/components/medicalEdit/specification/MedicalSpecificationRev4.vue";
import MedicalSpecificationRev3 from "@/components/medicalEdit/specification/MedicalSpecificationRev3.vue";
import MedicalSpecificationRev2 from "@/components/medicalEdit/specification/MedicalSpecificationRev2.vue";
import MedicalSpecificationRev1 from "@/components/medicalEdit/specification/MedicalSpecificationRev1.vue";
import MedicalInvoiceRev2 from "@/components/medicalEdit/invoice/MedicalInvoiceRev2.vue";

@Component({
  components: {
    LoadingDialog,
    MedicalSpecificationRev1,
    MedicalSpecificationRev2,
    MedicalSpecificationRev3,
    MedicalSpecificationRev4,
    MedicalSpecificationRev5,
    MedicalInvoiceRev2
  }
})
export default class MedicalEdit extends mixins(AxiosMixin) {
  private specifications: MedicalSpecification[] = []; //介護給付費データ
  private invoices: MedicalInvoice[] = []; //利用者向け請求書データ
  private sex_items: SelectItem[] = []; //性別選択アイテムリスト
  private beppyou_items: SelectItem[] = []; //別表選択アイテムリスト
  private visit_end_status_items: SelectItem[] = []; //訪問終了の状況アイテムリスト
  private die_place_items: SelectItem[] = []; //死亡場所ムリスト
  private ins_type_items: PulldownItem[] = []; //保険種類アイテムリスト
  private ins_multi_items: PulldownItem[] = []; //保険併用アイテムリスト
  private ins_div_items: PulldownItem[] = []; //保険区分アイテムリスト
  private reduction_unit_items: SelectItem[] = []; //減額単位アイテムリスト
  private reduction_type_items: SelectItem[] = []; //減額種類アイテムリスト
  private school_enter_items: SelectItem[] = []; //学校情報提供先アイテムリスト
  private visit_count_items: PulldownItem[] = []; //訪問回数アイテムリスト
  private indicate_day_items: PulldownItem[] = []; //特指示アイテムリスト
  private long_day_items: PulldownItem[] = []; //長時間アイテムリスト
  private multi_day_items: PulldownItem[] = []; //複数日アイテムリスト
  private same_building_day_items: PulldownItem[] = []; //同一建物アイテムリスト
  private same_emergency_day_items: PulldownItem[] = []; //同一緊急アイテムリスト
  private special_day_items: PulldownItem[] = []; //専門アイテムリスト
  private tax_rate_items: PulldownItem[] = []; //税率アイテムリスト

  private selectTabItem = 0; //選択中のタブ
  private specification_component_name = ""; //明細のコンポーネント名

  mounted() {
    this.updateData();
  }

  //データ取得
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/medical/edit/get_one",
      {
        patient_id: Number(this.$route.params.id),
        specification_id: Number(this.$route.query.specification_id)
      },
      res => {
        this.specifications = res.data.specifications;
        this.invoices = res.data.invoices;
        this.sex_items = res.data.sex_items;
        this.beppyou_items = res.data.beppyou_items;
        this.visit_end_status_items = res.data.visit_end_status_items;
        this.die_place_items = res.data.die_place_items;
        this.ins_type_items = res.data.ins_type_items;
        this.ins_multi_items = res.data.ins_multi_items;
        this.ins_div_items = res.data.ins_div_items;
        this.reduction_unit_items = res.data.reduction_unit_items;
        this.reduction_type_items = res.data.reduction_type_items;
        this.school_enter_items = res.data.school_enter_items;
        this.visit_count_items = res.data.visit_count_items;
        this.indicate_day_items = res.data.indicate_day_items;
        this.long_day_items = res.data.long_day_items;
        this.multi_day_items = res.data.multi_day_items;
        this.same_building_day_items = res.data.same_building_day_items;
        this.same_emergency_day_items = res.data.same_emergency_day_items;
        this.special_day_items = res.data.special_day_items;
        this.tax_rate_items = res.data.tax_rate_items;
        this.selectTabItem = res.data.select_tab;
        this.specification_component_name =
          res.data.specification_component_name;
      }
    );
  }

  //キャンセル
  private cancel() {
    this.$router.go(-1);
  }

  //保存
  private save() {
    if (!confirm("データを保存しますか？")) {
      return;
    }
    const specifications = this.specifications.map(specification => {
      const s = { ...specification };
      s.birthday = this.toResTime(s.birthday_str);
      s.doctor_report_date = this.toResTime(s.doctor_report_date_str);
      s.visit_start = this.toResTime(s.visit_start_str);
      s.visit_end = this.toResTimeHHMM(
        s.visit_end_str,
        s.visit_end_hh,
        s.visit_end_mm
      );
      s.die_date = this.toResTimeHHMM(
        s.die_date_str,
        s.die_date_hh,
        s.die_date_mm
      );
      s.indicate_date1_start = this.toResTime(s.indicate_date1_start_str);
      s.indicate_date1_end = this.toResTime(s.indicate_date1_end_str);
      s.indicate_date2_start = this.toResTime(s.indicate_date2_start_str);
      s.indicate_date2_end = this.toResTime(s.indicate_date2_end_str);
      s.indicate_special_date1_start = this.toResTime(
        s.indicate_special_date1_start_str
      );
      s.indicate_special_date1_end = this.toResTime(
        s.indicate_special_date1_end_str
      );
      s.indicate_special_date2_start = this.toResTime(
        s.indicate_special_date2_start_str
      );
      s.indicate_special_date2_end = this.toResTime(
        s.indicate_special_date2_end_str
      );
      s.indicate_special_date3_start = this.toResTime(
        s.indicate_special_date3_start_str
      );
      s.indicate_special_date3_end = this.toResTime(
        s.indicate_special_date3_end_str
      );
      s.indicate_mind_date1_start = this.toResTime(
        s.indicate_mind_date1_start_str
      );
      s.indicate_mind_date1_end = this.toResTime(s.indicate_mind_date1_end_str);
      s.indicate_mind_date2_start = this.toResTime(
        s.indicate_mind_date2_start_str
      );
      s.indicate_mind_date2_end = this.toResTime(s.indicate_mind_date2_end_str);
      s.indicate_mind_special_date1_start = this.toResTime(
        s.indicate_mind_special_date1_start_str
      );
      s.indicate_mind_special_date1_end = this.toResTime(
        s.indicate_mind_special_date1_end_str
      );
      s.indicate_mind_special_date2_start = this.toResTime(
        s.indicate_mind_special_date2_start_str
      );
      s.indicate_mind_special_date2_end = this.toResTime(
        s.indicate_mind_special_date2_end_str
      );
      s.indicate_mind_special_date3_start = this.toResTime(
        s.indicate_mind_special_date3_start_str
      );
      s.indicate_mind_special_date3_end = this.toResTime(
        s.indicate_mind_special_date3_end_str
      );
      s.calc_enter = this.toNumberCheck(s.calc_enter);
      s.calc_turn = this.toNumberCheck(s.calc_turn);
      if (s.calc_turn == 0) {
        s.calc_turn_count = 0;
      }
      s.notices_other1 = this.toNumberCheck(s.notices_other1);
      s.notices_other2 = this.toNumberCheck(s.notices_other2);
      s.notices_servant = this.toNumberCheck(s.notices_servant);
      s.notices_special_other = this.toNumberCheck(s.notices_special_other);
      s.notices_nursing = this.toNumberCheck(s.notices_nursing);
      s.notices_support = this.toNumberCheck(s.notices_support);
      s.notices_emergency = this.toNumberCheck(s.notices_emergency);
      s.notices_retirement = this.toNumberCheck(s.notices_retirement);
      s.notices_contact = this.toNumberCheck(s.notices_contact);
      s.notices_gaf = this.toNumberCheck(s.notices_gaf);
      s.notices_gaf_date = this.toResTime(s.notices_gaf_date_str);
      if (s.notices_gaf_points == null) {
        s.notices_gaf_points = "";
      } else {
        s.notices_gaf_points = "" + s.notices_gaf_points;
      }
      s.calc_before_yearmonth = s.calc_before_yearmonth_str.replace("-", "");

      s.visit_div1 = this.toNumberCheck(s.visit_div1);
      s.visit_div2 = this.toNumberCheck(s.visit_div2);
      s.visit_div3 = this.toNumberCheck(s.visit_div3);
      s.city_div1 = this.toNumberCheck(s.city_div1);
      s.city_div2 = this.toNumberCheck(s.city_div2);
      s.med_ins_div1 = this.toNumberCheck(s.med_ins_div1);
      s.med_ins_div2 = this.toNumberCheck(s.med_ins_div2);
      s.med_ins_div3 = this.toNumberCheck(s.med_ins_div3);

      s.calc_carechg = this.toNumberCheck(s.calc_carechg);
      s.basic_palliative = this.toNumberCheck(s.basic_palliative);
      s.basic_bedsore = this.toNumberCheck(s.basic_bedsore);
      s.basic_artificial = this.toNumberCheck(s.basic_artificial);
      s.add_palliative = this.toNumberCheck(s.add_palliative);
      s.add_bedsore = this.toNumberCheck(s.add_bedsore);
      s.add_artificial = this.toNumberCheck(s.add_artificial);
      s.add_specific_act = this.toNumberCheck(s.add_specific_act);
      s.manual_issue = this.toResTime(s.manual_issue_str);
      s.manual_review = this.toResTime(s.manual_review_str);
      return s;
    });
    const sBasics = this.specifications
      .flatMap(s => s.basics)
      .filter(b => b.total_money > 0);
    const sManagements = this.specifications
      .flatMap(s => s.managements)
      .filter(m => m.total_money > 0);
    const sMinds = this.specifications
      .flatMap(s => s.minds)
      .filter(m => m.total_money > 0);
    const sVistDays = this.specifications
      .flatMap(s => s.visit_days)
      .filter(
        v =>
          v.status1 > 0 ||
          v.status2 > 0 ||
          v.status3 > 0 ||
          v.status4 > 0 ||
          v.building > 0 ||
          v.emergency > 0 ||
          v.special > 0
      );
    const invoices = this.invoices.map(invoice => {
      const i = { ...invoice };
      i.invoice_range_start = this.toResTime(i.invoice_range_start_str);
      i.invoice_range_end = this.toResTime(i.invoice_range_end_str);
      if (!i.is_self_burden) {
        i.self_burden = null;
      }
      return i;
    });
    const iBurdenIns = this.invoices.flatMap(i => i.burden_ins_ins);
    const iBurdenOuts = this.invoices.flatMap(i => i.burden_ins_outs);
    const iVisitDays = this.invoices
      .flatMap(i => i.visit_days)
      .filter(
        v =>
          v.status1 > 0 ||
          v.status2 > 0 ||
          v.status3 > 0 ||
          v.status4 > 0 ||
          v.building > 0 ||
          v.emergency > 0
      );

    this.postJsonCheck(
      window.base_url + "/api/office/medical/edit/update",
      {
        specifications: specifications,
        specification_basics: sBasics,
        specification_minds: sMinds,
        specification_managements: sManagements,
        specification_visit_days: sVistDays,
        invoices: invoices,
        invoice_burden_ins_ins: iBurdenIns,
        invoice_burden_ins_outs: iBurdenOuts,
        invoice_visit_days: iVisitDays
      },
      () => {
        this.cancel();
      }
    );
  }

  //日変換
  private toResTime(datetime: string): string | null {
    return datetime ? new Date(datetime).toISOString() : null;
  }

  //日時変換
  private toResTimeHHMM(date: string, hh: string, mm: string): string | null {
    if (date) {
      const hour = hh ? hh : "0";
      const minute = mm ? mm : "0";
      return new Date(
        date.replaceAll("-", "/") + " " + hour + ":" + minute
      ).toISOString();
    } else {
      return null;
    }
  }

  //チェックボックス値変換
  private toNumberCheck(value: boolean | number): number {
    if (typeof value === "number") {
      return value;
    }
    if (value) {
      return 1;
    } else {
      return 0;
    }
  }
}
